import React, { Component, useState } from 'react';
import { Row, Col, Button, Label, FormGroup, Modal, ModalBody, ModalHeader, Card, CardBody, CardFooter, Form } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { BlankCard, SelectHotel, StyledCard } from '../../Base/Common/CommonUIComponents';
import CustomSelect from '../../Base/Common/CustomSelect';
import { getFonts, getVoucherTagLabel, getWidgetLanguages } from '../../Base/Common/ReferenceDataFunctions';
import { COLOR_FIELDS, widgetThemes } from './PredefinedThemes';
import WidgetPreview from './WidgetPreview';
import { getAPI } from '../../Base/API';
import { handleNotification } from '../../Base/Common/Notification';


const DEFAULT_COLORS = { ...widgetThemes[0].colors };

class WidgetConfig extends Component {
    static displayName = WidgetConfig.name;

    constructor(props) {
        super(props);
        this.state = {
            block:                false,
            hotelId:              null,
            selectedTheme:        'blue',
            isCustom:             false,
            themeMode:            'light',
            language:             null,
            font:                 null,
            colors:               { ...DEFAULT_COLORS },
            embedModal:           false,
            error:                [],
            voucherTags:          [],
            selectedVoucherTags:  [],
            blockTags:            false,
        };
    }

    componentDidMount() {        
        this.getVoucherTags();
    }
    
    getVoucherTags = () => {
        this.setState({ blockTags: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockTags: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }

                let tagOptions = [
                    { label: this.props.intl.formatMessage({ id: "generic.active" }), options: [] },
                    { label: this.props.intl.formatMessage({ id: "generic.inactive" }), options: [] }
                ];

                data.response && data.response.forEach((tag) => {
                    const obj = { label: getVoucherTagLabel(tag), value: tag.id };

                    tagOptions[tag.active ? 0 : 1].options.push(obj);
                });

                this.setState({ voucherTags: tagOptions, blockTags: false });
            }
            else {
                this.setState({ blockTags: false });
            }
        }, `/api/Voucher/Voucher/v1/voucherTag`)
    }    

    handleHotelChange = (combo) => {
        this.setState({ hotelId: combo ? combo.value : null });
    };

    handleThemeSelect = (themeId) => {
        if (themeId === 'custom') {
            this.setState({ selectedTheme: 'custom', isCustom: true });
        } else {
            const theme = widgetThemes.find(t => t.id === themeId);
            if (theme) {
                this.setState({ selectedTheme: themeId, isCustom: false, colors: { ...theme.colors }, themeMode: theme.mode || 'light' });
            }
        }
    };

    handleColorChange = (key, value) => {
        this.setState(prev => ({
            colors: { ...prev.colors, [key]: value },
            selectedTheme: 'custom',
            isCustom: true,
        }));
    };

    handleFontChange = (combo) => {
        this.setState({ font: combo ? combo.value : null });
    };

    handleLanguageChange = (combo) => {
        this.setState({ language: combo ? combo.value : null });
    };

    toggleEmbedModal = (e) => {
        e.preventDefault();
        if (!this.state.hotelId) return;
        this.setState(prev => ({ embedModal: !prev.embedModal }));
    };


    render() {
        const { intl } = this.props;
        const { block, hotelId, selectedTheme, isCustom, themeMode, colors, language, font, embedModal, error } = this.state;
        const langOptions = getWidgetLanguages(intl);

        return (
            <StyledCard icon={'fa-solid fa-gear'} title="WidgetConfig.Title" id="widgetConfig" error={error} block={block}>
                <Form onSubmit={this.toggleEmbedModal}>
                    <Row>
                        <Col lg={7} className="mb-3">
                            <FormGroup row className="mb-1">
                                <Col sm={12} md={6} className="mb-2">
                                    <Label><FormattedMessage id="generic.Hotel" /></Label>
                                    <SelectHotel 
                                        onChangeFunc={this.handleHotelChange} 
                                        value={this.state.hotelId} 
                                        required={true}
                                    />
                                </Col>
                                <Col sm={12} md={6} className="mb-2">
                                    <Label><FormattedMessage id="WidgetConfig.Language" /></Label>
                                    <CustomSelect
                                        placeholder="Language"
                                        options={langOptions}
                                        onChange={(combo) => this.handleLanguageChange(combo)}
                                        value={langOptions.find(lang => lang.value === this.state.language) || ''}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="mb-4" row>
                                <Col sm={12} md={6} className="mb-2">
                                    <Label><FormattedMessage id="VoucherPreview.Tags" /></Label>
                                    <CustomSelect
                                        name="voucherTagId"
                                        options={this.state.voucherTags}
                                        placeholder={<FormattedMessage id="VoucherPreview.Tags" />}
                                        isLoading={this.state.blockTags}
                                        isClearable
                                        isMulti={true}
                                        value={this.state.selectedVoucherTags}
                                        onChange={(selectedOptions) => this.setState({ selectedVoucherTags: selectedOptions || [] })}
                                    />
                                </Col>
                                <Col sm={12} md={6} className="mb-2">    
                                    <Label><FormattedMessage id="WidgetConfig.Font" /></Label>
                                    <CustomSelect
                                        placeholder={<FormattedMessage id="WidgetConfig.Font" />}
                                        options={getFonts()}
                                        onChange={(combo) => this.setState({ font: combo && combo.value })}
                                        value={getFonts().find(font => font.value === this.state.font) || ''}
                                    />
                                </Col>
                            </FormGroup>

                            <div>
                                <SectionHeader icon="fa-solid fa-palette" labelId="WidgetConfig.Theme" />

                                <Row>
                                    <Col sm={12} md={6} className="mb-2">
                                        <Label><FormattedMessage id="WidgetConfig.Theme" /></Label>
                                        <CustomSelect
                                            placeholder={<FormattedMessage id="WidgetConfig.Theme" />}
                                            options={[
                                                ...widgetThemes.map(theme => ({ value: theme.id, label: theme.name })),
                                                { value: 'custom', label: intl.formatMessage({ id: 'WidgetConfig.Theme.Custom' }) },
                                            ]}
                                            onChange={(combo) => this.handleThemeSelect(combo ? combo.value : null)}
                                            value={
                                                isCustom
                                                    ? { value: 'custom', label: intl.formatMessage({ id: 'WidgetConfig.Theme.Custom' }) }
                                                    : widgetThemes.map(t => ({ value: t.id, label: t.name })).find(t => t.value === selectedTheme) || ''
                                            }
                                        />
                                    </Col>
                                    <Col sm={12} md={6} className="mb-2 text-right">
                                        <Label><FormattedMessage id="WidgetConfig.DisplayMode" /></Label>
                                        <div className="d-flex align-items-center justify-content-end">
                                            <div className="btn-group btn-group-sm" role="group">
                                                <button
                                                    type="button"
                                                    disabled={!isCustom}
                                                    className={`btn ${themeMode === 'light' ? 'btn-host' : 'btn-outline-secondary'}`}
                                                    onClick={() => isCustom && this.setState({ themeMode: 'light' })}
                                                >
                                                    <i className="fa-solid fa-sun mr-1" />
                                                    <FormattedMessage id="WidgetConfig.Light" />
                                                </button>
                                                <button
                                                    type="button"
                                                    disabled={!isCustom}
                                                    className={`btn ${themeMode === 'dark' ? 'btn-host' : 'btn-outline-secondary'}`}
                                                    onClick={() => isCustom && this.setState({ themeMode: 'dark' })}
                                                >
                                                    <i className="fa-solid fa-moon mr-1" />
                                                    <FormattedMessage id="WidgetConfig.Dark" />
                                                </button>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                <ThemeTile
                                    theme={{ colors }}
                                    isCustom={isCustom}
                                    onColorChange={this.handleColorChange}
                                    intl={intl}
                                />
                            </div>
                        </Col>

                        <Col lg={5} className="mb-3">
                            <BlankCard block={false}>
                                <div className="border-bottom d-flex justify-content-between align-items-center mb-3 pb-2">
                                    <div className="text-muted" style={{ fontSize: '0.82rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                        <i className={`fa-solid fa-eye mr-2`} />
                                        <FormattedMessage id={'WidgetConfig.Section.Preview'} />
                                    </div>
                                    <div className="text-right">
                                        <Button className="btn-host btn-sm" type="submit">
                                            <i className="fa-solid fa-code mr-1" />
                                            <FormattedMessage id="WidgetConfig.EmbedCode" />
                                        </Button>
                                    </div>
                                </div>
                                <WidgetPreview colors={colors} font={font} themeMode={themeMode} />
                            </BlankCard>
                        </Col>

                    </Row>
                </Form>


                {embedModal && (
                    <EmbedCodeModal
                        isOpen={embedModal}
                        toggle={this.toggleEmbedModal}
                        hotelId={hotelId}
                        colors={colors}
                        language={language}
                        font={font}
                        themeMode={themeMode}
                        selectedTheme={selectedTheme}
                        isCustom={isCustom}
                        tags={this.state.selectedVoucherTags}
                    />
                )}
            </StyledCard>
        );
    }
}


const SectionHeader = ({ icon, labelId, }) => (
    <h6 className="text-muted border-bottom pb-2 mb-3" style={{ fontSize: '0.82rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        <i className={`${icon} mr-2`} />
        <FormattedMessage id={labelId} />
    </h6>
);

const ThemeTile = ({ theme, isCustom, onColorChange, intl }) => {
    if (!theme || !theme.colors) return null;

    return (
        <Row className="mt-3">
            {COLOR_FIELDS.map((colorField) => {
                const color = theme.colors[colorField.key];
                if (!color) return null;

                return (
                    <Col className="col-3 mb-3" key={colorField.key}>
                        <Card className="p-0 small" style={{ cursor: isCustom ? 'pointer' : 'default' }}>
                            <CardBody style={{ backgroundColor: color, position: 'relative', minHeight: '50px' }}>
                                {isCustom && (
                                    <input
                                        type="color"
                                        value={color}
                                        onChange={e => onColorChange(colorField.key, e.target.value)}
                                        title={intl.formatMessage({ id: colorField.labelKey })}
                                        style={{
                                            opacity: 0,
                                            position: 'absolute',
                                            top: 0, left: 0,
                                            width: '100%', height: '100%',
                                            cursor: 'pointer',
                                            border: 'none',
                                            padding: 0,
                                        }}
                                    />
                                )}
                            </CardBody>
                            <CardFooter>
                                <i className={`${colorField.icon} mr-1`} style={{ color, fontSize: '0.72rem' }} />
                                <FormattedMessage id={colorField.labelKey} />
                            </CardFooter>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

export default injectIntl(WidgetConfig);


const EmbedCodeModal = ({ isOpen, toggle, hotelId, colors, language, font, themeMode, selectedTheme, isCustom, tags }) => {
    const [copied, setCopied] = useState(false);
    const [copyError, setCopyError] = useState(false);
    const lines = [
        `  data-hotel-id="${hotelId || ''}"`,
        language    ? `  data-lang="${language}"`    : null,
        `  data-consent-cookies="false"`,
        font        ? `  data-font="${font}"`         : null,
        tags && tags.length > 0 ? `  data-tags="${tags.map(t => t.value).filter(Boolean).join(',')}"` : null,
        ...(isCustom ? [
            `  data-theme-mode="${themeMode}"`,
            `  data-primary="${colors.primary}"`,
            `  data-primary-hover="${colors.primaryHover}"`,
            `  data-secondary="${colors.secondary}"`,
            `  data-secondary-hover="${colors.secondaryHover}"`,
            `  data-text="${colors.text}"`,
            `  data-error="${colors.error}"`,
            `  data-success="${colors.success}"`,
            `  data-accent="${colors.accent}"`,
        ] : [
            `  data-theme="${selectedTheme}"`,
        ]),
    ].filter(Boolean);

    // Plain script, never type="module": the bundle is an IIFE and relies on
    // document.currentScript to find the host that serves the API proxy.
    const code = `<script src="${process.env.REACT_APP_WIDGET_V2_JS_URL}"
${lines.join('\n')}
></script>`;

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <i className="fa-solid fa-code mr-2" />
                <FormattedMessage id="WidgetConfig.EmbedCode" />
            </ModalHeader>
            <ModalBody>
                <div className="text-right mb-2">
                    <Button className={copyError ? "btn-danger" : copied ? "btn-success" : "btn-primary btn-host"} size="sm" onClick={() => {
                        if (navigator.clipboard) {
                            navigator.clipboard.writeText(code)
                                .then(() => { setCopied(true); setCopyError(false); setTimeout(() => setCopied(false), 2000); })
                                .catch(() => { setCopyError(true); setTimeout(() => setCopyError(false), 2000); });
                        }
                        else {                            
                            setCopyError(true);
                            setTimeout(() => setCopyError(false), 2000);
                        }
                    }}>
                        <i className={`fa-solid ${copyError ? 'fa-xmark' : copied ? 'fa-check' : 'fa-copy'} mr-1`} />
                        <FormattedMessage id={copyError ? 'WidgetConfig.CopyError' : copied ? 'WidgetConfig.Copied' : 'WidgetConfig.Copy'} />
                    </Button>
                </div>
                <pre style={{ backgroundColor: '#1e293b', color: '#e2e8f0', padding: '16px', borderRadius: '8px', fontSize: '0.78rem', overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                    {code}
                </pre>
            </ModalBody>
        </Modal>
    );
};